// extracted by mini-css-extract-plugin
export var downArrow = "_io-0";
export var infoTooltipIcon = "_io-3";
export var label = "_io-1";
export var optionCard = "_io-4";
export var upArrow = "_io-2";